import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { HOVER_SHADOW } from 'styles/theme';

const StyButton = styled(Button, {
    name: 'StyFavouriteDashboardContainer',
})(({ theme }) => ({
    backgroundColor: theme.palette.primary.background,
    color: theme.palette.darkGrey,
    height: '150px',
    display: 'flex',
    width: '250px',
    borderRadius: theme.spacing(2),
    maxWidth: '400px',
    padding: '32px 24px',
    '& .MuiTypography-body1': {
        textAlign: 'left',
        fontWeight: 600,
    },
    '&:hover': {
        boxShadow: HOVER_SHADOW,
        backgroundColor: theme.palette.primary.background,
    },
    boxShadow: '-4px 8px 24px 0px rgba(0, 0, 0, 0.06)',
}));

type Props = {
    openFavouriteDashboardModal: () => void;
};

const FavouriteDashboardManager = ({
    openFavouriteDashboardModal,
}: Props): JSX.Element => {
    const { t } = useTranslation();

    return (
        <div style={{ width: '100%' }}>
            <StyButton
                startIcon={
                    <AddCircleIcon
                        color="primary"
                        sx={{ height: 32, width: 32 }}
                    />
                }
                onClick={openFavouriteDashboardModal}
            >
                <Typography>{t('home.favourites.manage')}</Typography>
            </StyButton>
        </div>
    );
};

export default FavouriteDashboardManager;
